export default __webpack_public_path__ + "static/media/social-media-linkedin.f1160f94.svg";